/** Keep the loading reserve; compact single-box and completed two-box selections. */
class GrooviAppSlot extends HTMLElement {
  connectedCallback() {
    this.abortController = new AbortController();
    this.interacted = false;
    this.frame = 0;
    this.observedBars = null;
    const options = { signal: this.abortController.signal };
    this.addEventListener('click', (event) => this.onSelection(event), options);
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') this.onSelection(event);
    }, options);
    this.observer = new MutationObserver(() => this.schedule());
    this.observer.observe(this, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    this.resizeObserver = new ResizeObserver(() => this.schedule());
  }

  disconnectedCallback() {
    this.abortController.abort();
    this.observer.disconnect();
    this.resizeObserver.disconnect();
    cancelAnimationFrame(this.frame);
    this.style.removeProperty('min-block-size');
  }

  onSelection(event) {
    if (!(event.target instanceof Element) || !event.target.closest('.kaching-bundles__bar')) return;
    this.interacted = true;
    this.schedule();
  }

  schedule() {
    if (!this.interacted || this.frame) return;
    this.frame = requestAnimationFrame(() => {
      this.frame = 0;
      this.updateSpacing();
    });
  }

  updateSpacing() {
    const selected = this.querySelector('.kaching-bundles__bar--selected');
    const bars = this.querySelector('.kaching-bundles__bars');
    let deal;
    try {
      const settings = JSON.parse(this.querySelector('script.kaching-bundles-deal-block-settings')?.textContent || '{}');
      deal = settings.dealBars?.find((bar) => bar.id === selected?.dataset.dealBarId);
    } catch {
      // Unknown app markup keeps the configured loading reserve.
    }
    const quantity = Number(deal?.quantity);
    const completePair = quantity === 2
      && selected.querySelectorAll('.kaching-bundles__collection-product').length === 2
      && !selected.querySelector('.kaching-bundles__collection-product__choose-product-button');
    if ((quantity !== 1 && !completePair) || !bars) {
      this.style.removeProperty('min-block-size');
      this.resizeObserver.disconnect();
      this.observedBars = null;
      return;
    }
    if (this.observedBars !== bars) {
      this.resizeObserver.disconnect();
      this.resizeObserver.observe(bars);
      this.observedBars = bars;
    }
    const last = bars.querySelector('.kaching-bundles__bar:last-child');
    if (!last || !this.getClientRects().length) return;
    // The adjacent purchase group already contributes 12px. Leave 12px here
    // as well, based on actual card geometry rather than a tier title or index.
    const height = last.getBoundingClientRect().bottom - this.getBoundingClientRect().top + 12;
    const value = `${height}px`;
    if (this.style.minBlockSize !== value) this.style.minBlockSize = value;
  }
}

if (!customElements.get('groovi-app-slot')) customElements.define('groovi-app-slot', GrooviAppSlot);
